import { HubspotAppRow } from '../components/HubspotAppRow';
import type { AppRow } from '../type/AppRow';

export const hubspotAppRow: AppRow = {
  key: 'hubspot',
  name: 'HubSpot',
  AppComponent: HubspotAppRow,
};
